import { Injectable } from '@angular/core';

export interface FilterSearchState {
  key: string;
  component: string;
  group?: string;
  value: string | string[];
}

@Injectable()
export class FilterSearchStateService {
  constructor() {}

  setState(state: FilterSearchState) {
    let storedState: any = JSON.parse(localStorage.getItem(`FilterSearchStateService_${state.component}`));
    storedState = storedState || {};
    if (state.group) {
      storedState[state.group] = storedState[state.group] || {};
      storedState[state.group][state.key] = state.value;
    } else {
      storedState[state.key] = state.value;
    }
    localStorage.setItem(`FilterSearchStateService_${state.component}`, JSON.stringify(storedState));
  }

  getState(component: string, key: string, group?: string): FilterSearchState {
    const componentStoredState: any = JSON.parse(localStorage.getItem(`FilterSearchStateService_${component}`));
    if (componentStoredState) {
      return { key: key, component: component, value: (componentStoredState[group] || componentStoredState)[key] };
    } else {
      return { key: key, component: component, value: null };
    }
  }
}
